import * as yup from 'yup'

export const VALIDATE = {
  supplierContacts: yup.array().of(
    yup.object().shape({
      nmContato: yup
        .string()
        .when('txEmail', (txEmail, schema) =>
          txEmail
            ? schema
                .required('Contato necessário quando tiver um e-mail')
                .min(3, 'Mínimo 3 caracteres')
                .max(50, 'Máximo 50 caracteres')
            : schema.nullable()
        ),
      txEmail: yup
        .string()
        .test({
          exclusive: false,
          message: 'E-mail necessário quando tiver um contato',
          name: 'required',
          params: {},
          test: function (value) {
            if (this.parent.nmContato?.length > 0) {
              return value?.length > 0
            }
            return true
          }
        })
        //.email('E-mail inválido.')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
        .max(50, 'Máximo 50 caracteres')
    })
  )
}
